export default __webpack_public_path__ + "static/media/plus-single.eea42e50.svg";